import { render } from "./FluentIcon.vue?vue&type=template&id=568d4872&scoped=true"
import script from "./FluentIcon.vue?vue&type=script&lang=js"
export * from "./FluentIcon.vue?vue&type=script&lang=js"

import "./FluentIcon.vue?vue&type=style&index=0&id=568d4872&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-568d4872"]])

export default __exports__